import React, { useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { AddBox } from "@material-ui/icons";
import { Box, Button } from "@material-ui/core";
// import AccessListTable from "./AccessListTable";
// import AddUserAccessDialog from "./AddUserAccessDialog";
// import AddBatchAccessDialog from "./AddBatchAcessDialog";
import EventTokenTable from "./EventTokenTable";
import AddEventTokenDialog from "./AddEventTokenDialog";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  actionsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 20px",
  },
  buttonsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
}));

const EventToken = () => {
  const classes = useStyles();
  const [openAddEventTicketToken, setOpenAddEventTicketToken] = useState(false);
  const [openAddBatchUser, setOpenAddBatchUser] = useState(false);
  const [searchVal, setSearchVal] = useState("");

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <Box className={classes.actionsContainer}>
          <Box className={classes.buttonsContainer}>
            <Box>
              {/* <CmtSearch
                border={false}
                onlyIcon={false}
                iconPosition="left"
                align="left"
                placeholder="جست و جو"
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
              /> */}
            </Box>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<AddBox />}
              onClick={() => setOpenAddEventTicketToken(true)}
              style={{ marginRight: 14, marginBlock: "10px" }}
            >
              اضافه کردن دسترسی
            </Button>
          </Box>
        </Box>
        <EventTokenTable />
      </CmtCardContent>
      <AddEventTokenDialog
        open={openAddEventTicketToken}
        handleClose={() => setOpenAddEventTicketToken(false)}
      />
    </CmtCard>
  );
};

export default EventToken;
